<template>
  <div id="modal-example" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
      <span class="uk-label uk-label-warning uk-float-right">BETA</span>
      <h2>{{ $t("setup.configuration.header")}}</h2>
      <p>{{ $t("setup.configuration.detail")}}</p>
      <div class="uk-padding uk-padding-remove-top">
        <div class="uk-grid-small" v-for="bird in birds" uk-grid>
          <span class="uk-text-bold uk-width-1-3@s">{{ bird.name }}</span>
          <span class="uk-text-lighter uk-text-truncate uk-width-1-3@s">{{ bird.filename}}</span>
          <div class="uk-width-1-3@s">
            <button class="uk-button uk-button-secondary uk-button-small"
                    :disabled="preventPlayingSound(bird)"
                    @click="soundButtonClicked(bird)">{{ $t(playOrStop(bird)) }}</button>
            <button class="uk-button uk-button-danger uk-button-small" @click="birdRemoved(bird)">{{ $t("setup.configuration.remove")}}</button>
          </div>
        </div>
      </div>
      <div>
        <configuration-entry @birdAdded="birdAdded"></configuration-entry>
      </div>
      <p><span v-if="!uniqueSounds">{{ $t("setup.configuration.errors.fileDuplicate") }}</span></p>
      <p class="uk-text-right">
        <button class="uk-button uk-button-primary uk-modal-close" :disabled="!valid" type="button" @click="storeLevel">{{ $t("buttons.save")}}</button>
      </p>
    </div>
  </div>
</template>
<script>
  import ConfigurationEntry from "./ConfigurationEntry.vue"
  import { mapGetters } from "vuex"

  export default {
    data() {
      return {
        birds: [],
        soundToPlay: null,
        birdPlaying: null
      }
    },
    methods: {
      ...mapGetters(["language", "levels"]),
      birdAdded(card) {
        let i = this.birds.map(b => b.name).indexOf(card.name);
        if (i > -1) {
          this.birds.splice(i, 1, { name: card.name, filename: card.filename });
        } else {
          this.birds.splice(this.birds.length, 1, { name: card.name, filename: card.filename });
        }
      },
      birdRemoved(bird) {
        let i = this.birds.indexOf(bird);
        this.birds.splice(i, 1);
      },
      preventPlayingSound(bird) {
        if (!this.soundPlaying) return false;
        return !(this.birdPlaying === bird)
      },
      tryBirdSound(bird) {
        this.soundToPlay = new Howl({src: [bird.filename], html5: true});
        this.soundToPlay.play();
        this.birdPlaying = bird;
      },
      playOrStop(bird) {
        let word;
        if (this.soundPlaying && this.birdPlaying === bird) {
          word = "setup.configuration.stop"
        } else {
          word = "setup.configuration.play"
        }
        return word;
      },
      soundButtonClicked(bird) {
        !this.soundPlaying ? this.tryBirdSound(bird) : this.stopBirdSound(bird)
      },
      stopBirdSound(bird) {
        if (this.soundToPlay) {
          this.soundToPlay.stop();
          this.birdPlaying = null;
        }
      },
      storeLevel() {
        let level = this.birds.map(c => { return {filename: c.filename, name_cs: c.name, name: c.name} })

        this.$store.dispatch("storeCustomLevel", level);
      }
    },
    created() {
      if (this.$store.getters.ownLevelSet) {
        this.birds = this.levels()["X"]
      }
    },
    computed: {
      soundPlaying() {
        return !(this.birdPlaying === null);
      },
      valid() {
        return this.anyBird && this.uniqueSounds
      },
      anyBird() {
        return this.birds.length > 0;
      },
      uniqueSounds() {
        return (new Set(this.birds.map(b => b.filename)).size) === this.birds.length
      }
    },
    components: {
      ConfigurationEntry: ConfigurationEntry
    }
  }
</script>
<style scoped>
.uk-modal-dialog {
  width: 700px;
}
</style>



// WEBPACK FOOTER //
// src/components/Configuration.vue